import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LedDesign } from '../../../models/led-board.model';

@Component({
  selector: 'app-start-screen',
  templateUrl: './start-screen.component.html',
  styleUrls: ['./start-screen.component.scss'],
  standalone: false,
})
export class StartScreenComponent {
  /** Data URL of what the board is showing right now, or null if nothing is. */
  @Input() livePreview: string | null = null;
  /** True when the board is playing an animation rather than a still. */
  @Input() liveAnimated = false;
  @Input() designs: LedDesign[] = [];

  /** A session running right now, which anyone nearby can join. */
  /** While sessions are switched off, the board never offers one. */
  @Input() sessionsEnabled = false;
  @Input() sessionLive = false;
  @Input() sessionCountdown = '';
  @Input() sessionPeople = 0;

  @Output() join = new EventEmitter<void>();
  @Output() session = new EventEmitter<void>();
  @Output() draw = new EventEmitter<void>();
  @Output() photo = new EventEmitter<void>();
  @Output() gallery = new EventEmitter<void>();

  /** A few thumbnails to show that the gallery has something in it. */
  get previewThumbs(): LedDesign[] { return this.designs.slice(0, 3); }

  get galleryHint(): string {
    const n = this.designs.length;
    if (!n) { return 'Nothing saved yet'; }
    return n === 1 ? 'Send the one saved design' : `Send one of ${n} saved designs`;
  }

  get sessionPeopleText(): string {
    const n = this.sessionPeople;
    if (n <= 0) { return 'Nobody has started yet'; }
    return n === 1 ? '1 person is drawing right now' : `${n} people are drawing right now`;
  }

  trackByDesign(_i: number, d: LedDesign) { return d.key || d.name; }
}
